export function useCacheProviderAPI() {
  const { errors, request } = useRequest();

  async function fetchAccountSettings(requestBody: (keyof AccountSettings)[]) {
    const url = 'V3/AccountSettings/ById';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AccountSetting[]>(url, requestOptions);
  }

  return {
    errors,
    fetchAccountSettings
  };
}
